import { render, staticRenderFns } from "./FeedbackChip.vue?vue&type=template&id=5b22adef&scoped=true"
import script from "./FeedbackChip.vue?vue&type=script&lang=ts"
export * from "./FeedbackChip.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackChip.vue?vue&type=style&index=0&id=5b22adef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b22adef",
  null
  
)

export default component.exports